import { render } from "./NcrmPrivacyPurposeDrawer.vue?vue&type=template&id=e060511a&scoped=true"
import script from "./NcrmPrivacyPurposeDrawer.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyPurposeDrawer.vue?vue&type=script&lang=js"

import "./NcrmPrivacyPurposeDrawer.vue?vue&type=style&index=0&id=e060511a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e060511a"]])

export default __exports__